import { render, staticRenderFns } from "./vsSidebarGroup.vue?vue&type=template&id=03dfb3d2&"
import script from "./vsSidebarGroup.vue?vue&type=script&lang=js&"
export * from "./vsSidebarGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsSidebarGroup.vue"
export default component.exports